<section class="mt-2">
  <span><button class="btn btn-secondary mt-2" (click)="openProductCharForAddEdit()"><i class="fa fa-plus-circle"
        aria-hidden="true"></i> Add</button></span>
  <table class="table table-hover white_box shadow" style="margin-top: 10px;">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">News</th>
        <th scope="col">Image</th>
        <th scope="col">URL</th>
        <th scope="col">Section</th>
        <th scope="col">Product Category</th>
        <th scope="col">Product Region</th>
        <th scope="col">Created</th>
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>

      <tr *ngFor="let item of allNews; let i = index;">
        <th scope="row">{{i + 1}}</th>
        <td><textarea rows="3" [disabled]="true" readonly [value]="item?.text"
            style="width: 25rem;padding: 5px;"></textarea></td>
        <td> <img loading="lazy" style="height: 5rem;" [src]="imgUrl + item.image"></td>
        <td>{{item?.url }}</td>
        <td>{{item?.category }}</td>
        <td>
          <div class="row">
            <ng-container *ngFor="let s of  item?.categoryList">
              <span class="sub-cate p-2 m-2" style="width: 80%;" *ngIf="s">{{ s }}</span>
            </ng-container>
          </div>
        </td>
        <td>
          <div class="row">
            <ng-container *ngFor="let s of  item?.subRegionList">
              <span class="sub-cate p-2 m-2" style="width: 80%;" *ngIf="s">{{ s }}</span>
            </ng-container>
          </div>
        </td>
        <td>{{item?.created | date:"dd/MM/yyyy" }}</td>



        <td class="text-right">
          <section class="d-flex justify-content-center">
            <button class="btn btn-info" (click)="openProductCharForAddEdit(item)">
              <i class="fa fa-pencil" aria-hidden="true"></i>
              Edit
            </button>
            <button class="btn btn-secondary ml-2" (click)="assign(item)"><i class="fa fa-users" aria-hidden="true"></i>
              Assign</button>
            <button class="btn btn-danger  ml-2" (click)="deleteAds(item?.id)">
              <i class="fa fa-trash" aria-hidden="true"></i> Delete
            </button>
          </section>
        </td>
      </tr>
    </tbody>
  </table>
</section>

<ng-template #AddNews let-modal>
  <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
    <div class=""></div>
    <div class="modal-body">
      <form [formGroup]="form">

        <img loading="lazy" *ngIf="imageBase64" class="map-search-listing-img mt-2 product-char-image w-100" [src]="imageBase64"
          alt="" />
        <img loading="lazy" *ngIf="selectedAds?.image" class="map-search-listing-img mt-2 product-char-image"
          [src]="imgUrl + selectedAds?.image">

        <button class="com_btn px-1 month-list-add-more mt-3" (click)="upload.click()">
          <i class="fas fa-plus"></i> Upload Event Image
        </button>
        <input type="file" #upload (change)="saveProductCharSelectedImage($event)"
          class="suggestion-modal-pic-input d-none" accept="image/*" />

        <div class="row">

          <div class="form-group col-12">
            <label for="exampleInputEmail1">News </label>
            <textarea type="text" formControlName="news" class="form-control" row="6" id="exampleInputEmail1"
              aria-describedby="emailHelp" placeholder="Enter Event Name"></textarea>
          </div>

          <div class="form-group col-12">
            <label>URL </label>
            <input type="text" rows="3" placeholder="Enter URL" class="form-control" formControlName="url">
          </div>

          <div class="form-group col-12">
            <label>Author </label>
            <input type="text" rows="3" placeholder="Enter URL" class="form-control" formControlName="author">
          </div>

          <div class="form-group col-12">
            <label>Section</label>
            <select formControlName="category" class="form-control">
              <option value="">Select</option>
              <option value="SG News">SG News</option>
              <option value="Promotions">Promotions</option>
              <option value="Funny">Funny</option>
              <option value="Business">Business</option>
            </select>
          </div>
        </div>



        <div class="mt-3 text-right">
          <button class="btn btn-secondary mr-2" (click)="modalDismissAll()">
            <i class="fa-solid fa-times"></i> Cancel
          </button>
          <button class="btn btn-primary" (click)="save()">
            <i class="fa-solid fa-save"></i> Save
          </button>
        </div>

      </form>
    </div>
  </div>
</ng-template>

<ng-template #AssignOption let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Assign Article</h4>
    <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body">



    <section>
      <div>Category :</div>
      <select2 [overlay]="false" [data]="categoryDropdown" [value]="categorySelectedDropdown" multiple="true"
        (update)="update( $event)" hideSelectedItems="true" id="selec2-10">
      </select2>
    </section>

    <section>
      <div>Sub Region :</div>
      <select2 [overlay]="false" [data]="regionDropdown" [value]="regionSelectedDropdown" multiple="true"
        (update)="updateRegion( $event)" hideSelectedItems="true" id="selec2-10">
      </select2>
    </section>

    <duv class="d-flex justify-content-end mt-2">
      <button type="button" class="btn btn-secondary" (click)="assignArticles()">
        Assign
      </button>
    </duv>
  </div>
</ng-template>